import { User } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@entities/app/user.entity';

/**
 * Nom sous lequel on s'adresse à l'utilisateur : le prénom, à défaut le pseudo,
 * sinon une chaîne vide (jamais « null »). Une seule règle pour l'accueil
 * (« Bonjour Olivier ») et le Compte. L'inscription par e-mail enregistre un
 * prénom fait d'un espace : un prénom blanc compte pour absent.
 */
export function userDisplayName(user: Partial<User> | null | undefined): string {
  return (user?.firstName ?? '').trim() || (user?.pseudo ?? '').trim();
}

/**
 * Lettre de l'avatar quand il n'y a pas de photo : celle du nom, sinon celle de
 * l'e-mail ; vide quand on ne sait rien (l'écran met alors une icône).
 */
export function userInitial(user: Partial<User> | null | undefined): string {
  return (userDisplayName(user) || (user?.email ?? '').trim()).charAt(0).toUpperCase();
}
